'use client';

import { usePathname } from 'next/navigation';
import { usePostHog } from 'posthog-js/react';

export function usePostHogEvents() {
  const posthog = usePostHog();
  const pathname = usePathname();

  const sendButtonClickEvent = (label: string, product_name: string) => {
    try {
      if (label === 'Learn More') {
        console.log('run');
        posthog.capture('Learn_More_Button_Click', {
          page_url: pathname,
          product_name: product_name,
        });
      }
      if (label === 'Get Started Now') {
        posthog.capture('Get_Started_Button_Click', {
          page_url: pathname,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendPdfDownloadEvent = (name: string) => {
    try {
      posthog?.capture('PDF_Download', {
        page_url: pathname,
        pdf_file_name: name,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const sendStoreSearchEvent = () => {
    try {
      posthog.capture('Store_Search_Done');
    } catch (error) {
      console.log(error);
    }
  };

  const sendExploreButtonClickEvent = (id: string, name: string) => {
    try {
      posthog.capture('Explore_Button_Click', {
        product_id: id,
        page_url: pathname,
        product_name: name,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const sendWhereToBuyEvent = (id: string, name: string) => {
    try {
      posthog.capture('Where_To_Buy_Button_Click', {
        product_id: id,
        page_url: pathname,
        product_name: name,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const sendDistributorClickEvent = (
    product_id: string,
    product_name: string,
    distributor: string
  ) => {
    try {
      posthog.capture('Distributor_Purchase_Link_Click', {
        product_id: product_id,
        page_url: pathname,
        product_name: product_name,
        distributor_name: distributor,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const sendVideoPlayEvent = (video_name: string) => {
    try {
      posthog.capture('Video_Play', {
        page_url: pathname,
        video_name: video_name,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return {
    sendButtonClickEvent,
    sendPdfDownloadEvent,
    sendStoreSearchEvent,
    sendExploreButtonClickEvent,
    sendWhereToBuyEvent,
    sendDistributorClickEvent,
    sendVideoPlayEvent,
  };
}
